/**
 * GO Commerce Session Expiry Handler Plugin
 * 
 * Initializes the session manager to handle session expiration gracefully.
 * This ensures users are automatically redirected to the account page when their session expires.
 */

import { defineNuxtPlugin } from '#app';
import { initSessionManager } from '@/utils/sessionManager';

export default defineNuxtPlugin(nuxtApp => {
  // Skip initialization on server-side
  if (process.server) return;
  
  // Initialize session management on client-side only
  initSessionManager();
  
  // Log initialization 
  console.log('[Plugin] Session expiry handler initialized');
});
